/**
 * @spec docs/specs/features/staking-ui-batched-reads.md (R10)
 */

/**
 * Public RPC endpoints by chain id, for external wallets only: Privy `rpcUrls.default`
 * (lib/privy.ts) and `wallet_addEthereumChain` (useNetworkSwitch). They are keyless public
 * endpoints. The app's own reads never use them (lib/provider.ts relays through rewards-api), and
 * neither the relay URL nor a keyed URL may appear here.
 */
export const PUBLIC_RPC_URLS = {
  8453: 'https://mainnet.base.org',
  84532: 'https://sepolia.base.org',
  // polygon-rpc.com answers every call with 403 "tenant disabled" (checked 2026-10-15)
  137: 'https://polygon-bor-rpc.publicnode.com',
} as const satisfies Record<number, string>;
